module.exports = __webpack_public_path__ + "static/media/loader.018d2ac3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/modules/images/loader.gif
// module id = 59
// module chunks = 27